// Copyright (c) 2021 WiseTime. All rights reserved.

import {
  ImmediatelyDeleteTimeRowsRequest,
  ImmediatelyDeleteTimeRowsResponse
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { grpc } from "../../../app/rpc/executor"
import { timelineClient } from "../../../app/rpc/client"
import * as Actions from "../actions"
import { Action } from "redux"
import * as TimelineSlice from "../slices/timeline"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type ImmediatelyDeleteTimeRowsRpc = (request: ImmediatelyDeleteTimeRowsRequest) => Observable<ImmediatelyDeleteTimeRowsResponse>

export const immediatelyDeleteTimeRows = (immediatelyDeleteTimeRowsRpc: ImmediatelyDeleteTimeRowsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.immediatelyDeleteTimeRows.match),
      mergeMap(({ payload: request }) => of(request)
        .pipe(
          mergeMap(immediatelyDeleteTimeRowsRpc),
          map(_ => TimelineSlice.deleteTimeRows(request.getTimeRowIdsList())),
          catchError(_ => of(showSnackBar({
            message: t({ id: "msg_immediately_delete_time_rows_failed", message: "Failed to delete. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          })))),
      )
    )

const immediatelyDeleteTimeRowsRpc = (request: ImmediatelyDeleteTimeRowsRequest): Observable<ImmediatelyDeleteTimeRowsResponse> =>
  grpc(() => timelineClient.immediatelyDeleteTimeRows(request, null))

export default immediatelyDeleteTimeRows(immediatelyDeleteTimeRowsRpc)
